import React from "react";
import { Card, Typography } from "antd";
import { ToolOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";

const { Title, Text } = Typography;

const ToolsPage: React.FunctionComponent = () => {
    const intl = useIntl();

    return (
        <div style={{ maxWidth: 600, margin: '80px auto', textAlign: 'center' }}>
            <Card>
                <div style={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    background: 'rgba(245, 158, 11, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px'
                }}>
                    <ToolOutlined style={{ fontSize: 36, color: '#F59E0B' }} />
                </div>
                <Title level={3}>
                    {intl.formatMessage({ id: 'layout.dashboard.menu.tools' })}
                </Title>
                <Text type="secondary" style={{ fontSize: 16 }}>
                    Coming Soon
                </Text>
            </Card>
        </div>
    );
};

export default ToolsPage;
